import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';

export const selectColumns = (state:RootState) => state[Reducers.Ui].columns;
export const selectCompare = (state:RootState) => state[Reducers.Ui].compare;

export const selectShowRecordsSidebar = (state:RootState) => state[Reducers.Ui].showRecordsSidebar;

export const selectColumnValue = createSelector(
  [ selectColumns ],
  (columns:string) => columns.split('_')[1]
);

export const selectIsInCompare = createSelector(
  [
    selectCompare,
    (_, props:{ id:string }) => props
  ],
  (compare:string[], { id }) => compare.includes(id)
);

// ToDO
export const selectWorkspaceType = (state:RootState) => state[Reducers.Ui].workspaceType;
